import React from 'react'
import footerLogo from 'assets/FirstBite-Logo-Green.png'
import { FooterSignedInAs } from './FooterSignedInAs'

interface NewFooterProps {
  className?: string
}

export const NewFooter: React.FC<NewFooterProps> = ({ className }) => {
  const supportEmail = 'support@firstbite.io'

  return (
    <footer
      className={`flex items-center justify-between h-[var(--footer-height)] min-h-[var(--footer-height)] px-6 bg-transparent rounded-b-lg ${className || ''}`}
    >
      {/* Left Section - Signed in as */}
      <FooterSignedInAs />

      {/* Right Section - Links and Logo */}
      <div className="flex items-center gap-3">
        <div className="flex items-center">
          <a
            href="/privacy-policy"
            className="flex items-center justify-center h-8 px-3 py-1.5 text-[#06512f] text-sm font-light font-inter no-underline cursor-pointer transition-all duration-150 rounded hover:text-[#2c6b4e] hover:font-medium hover:no-underline active:text-[#06512f] active:font-medium"
          >
            Privacy Policy
          </a>
          <a
            href="/terms-of-use"
            className="flex items-center justify-center h-8 px-3 py-1.5 text-[#06512f] text-sm font-light font-inter no-underline cursor-pointer transition-all duration-150 rounded hover:text-[#2c6b4e] hover:font-medium hover:no-underline active:text-[#06512f] active:font-medium"
          >
            Terms of Use
          </a>
          <a
            href={`mailto:${supportEmail}`}
            className="flex items-center justify-center h-8 px-3 py-1.5 text-[#06512f] text-sm font-light font-inter no-underline cursor-pointer transition-all duration-150 rounded hover:text-[#2c6b4e] hover:font-medium hover:no-underline active:text-[#06512f] active:font-medium"
          >
            Contact Us
          </a>
        </div>
        <div className="flex items-center justify-center h-10 py-2.5">
          <img src={footerLogo} alt="First Bite" className="h-6 w-[97px]" />
        </div>
      </div>
    </footer>
  )
}
